<template>
    <div :class="$style.content">
        <div :class="$style.abtestTypes">
            <div :class="$style.typeCards">
                <template v-for="item in typeLlist" :key="item.key">
                    <div :class="$style.card">
                        <h5 :class="$style.subtitle">{{ t(item.abname) }}</h5>
                        <ul>
                            <li v-for="(l, index) in item.introList" :key="index">{{ t(l) }}</li>
                        </ul>
                        <pt-button
                            type="contain"
                            :class="$style.button"
                            @click="handleTypeClick(item.key)"
                        >
                            {{ t(item.abButtonText) }}
                        </pt-button>
                    </div>
                </template>
            </div>
            <pt-link
                :underline="true"
                :class="$style.link"
                v-if="experienceNonABTestList?.length"
                @click="handleTypeClick('NonABTestList')"
            >
                {{ $t('experience.onboarding.run_with_existing_campaign') }}
            </pt-link>
        </div>
        <div :class="$style.ideas" @click="handleTypeClick('ABTEST')">
            <div :class="$style.left">
                <img src="/icons/pt-pic-exploretestingideas.svg" alt="" :class="$style.img" />
                <div :class="$style.leftContent">
                    <h3 :class="$style.title">
                        {{ $t('experience.onboarding.explore_test_ideas') }}
                    </h3>
                    <p :class="$style.desc">
                        {{ $t('experience.onboarding.explore_test_ideas_desc') }}
                        <pt-icon icon="icon-arrow-right" :class="$style.arrow"></pt-icon>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'ExperienceABTestTypeSelect'
};
</script>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { experienceTypeList } from '@experience/static/config/experience.config';
import useExperienceNonABTestList from '@models/experience/experienceNonABTestList';
import { CreateData } from '@experience/store/experience.create.store';
import { usePermission } from '@models/profile/useProfilePermission';
import analyticsService from '@assets/services/analytics.service';

const emit = defineEmits(['close', 'update']);

const { t } = useI18n();
const { hasExperienceAdvancePermission } = usePermission();
const experienceNonABTestList = ref();
const typeLlist = computed(() => {
    return experienceTypeList.filter(item => {
        return (
            !['ABTEST', 'REDIRECT'].includes(item.key) &&
            (item.key !== 'ADVANCED' || hasExperienceAdvancePermission.value)
        );
    });
});

onMounted(async () => {
    experienceNonABTestList.value = await useExperienceNonABTestList();
});

function handleTypeClick(key: any) {
    let type_select = key.toLocaleLowerCase();
    const data: CreateData = {
        experienceType: key
    };
    switch (key) {
        case 'POPUP':
        case 'ABTEST':
            data.fullscreenDialog = {
                component: 'ExperienceTemplate',
                componentData: {
                    templateItem: experienceTypeList.find(item => item.key === key),
                    templateListType: experienceTypeList.find(item => item.key === key)
                },
                backComponent: 'ExperienceABTestTypeSelect'
            };
            key === 'INLINE' && (type_select = 'ideas');
            break;
        case 'INLINE':
        case 'ADVANCED':
            data.dialog = {
                component: 'ExperienceForm',
                componentData: {
                    visibleBack: false
                }
            };
            break;
        case 'NonABTestList':
            data.dialog = {
                component: 'ExperienceNonABTestList',
                componentData: {
                    experienceNonABTestList: experienceNonABTestList.value,
                    visibleBack: false
                }
            };
            type_select = 'exsisting';
            break;
    }
    emit('update', data);

    analyticsService
        .usePTX('cp_add_ab_select', {
            type_select
        })
        .track();
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.content {
    max-width: 1200px;
    margin: 0 auto;
}
.abtestTypes {
    .typeCards {
        display: flex;
        align-items: center;
        justify-content: center;
        .card {
            flex: 1;
            position: relative;
            padding: 32px 28px;
            border: 1px solid $pt-black-40;
            border-radius: 8px;
            min-height: 238px;
            &:not(:nth-last-of-type(1)) {
                margin-right: 48px;
            }

            .subtitle {
                font-size: 20px;
                color: $pt-black-900;
                font-weight: 500;
                margin-bottom: 12px;
            }
            ul {
                margin-left: 20px;
                li {
                    font-size: 13px;
                    margin-bottom: 8px;
                    color: $pt-black-600;
                    list-style: disc;
                }
            }
            .button {
                min-width: 168px;
                position: absolute;
                bottom: 28px;
            }
        }
    }
    .link {
        margin-top: 32px;
    }
}
.ideas {
    margin-top: 44px;
    // height: 152px;
    padding: 26px 40px;
    background-color: #e6f7ff;
    border: 1px solid rgba(0, 184, 252, 0.5);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 4px rgb(9, 30, 66, 0.3);
    }
    .left {
        display: flex;
        align-items: center;
        .img {
            height: 104px;
            object-fit: contain;
        }
        .leftContent {
            margin-left: 24px;
            .title {
                font-size: 20px;
                font-weight: 500;
                color: $pt-black-900;
                line-height: 32px;
            }
            .desc {
                font-size: 13px;
                line-height: 20px;
                margin-top: 4px;
            }
        }
    }
    .arrow {
        margin-left: 5px;
        transition: 0.2s linear;
    }
    &:hover {
        .arrow {
            margin-left: 10px;
        }
    }
}
</style>
